<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label for="backup_name" class="form-control-label">{{$t('backup.name')}}</label>
      <input
        id="backup_name"
        v-model="item.name"
        :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('name', $event.target.value)">
      <div v-if="isInvalid('name')" class="invalid-feedback">{{ violations.name }}</div>
    </div>

    <div class="form-group">
      <label for="backup_description" class="form-control-label">{{$t('backup.description')}}</label>
      <input
        id="backup_description"
        v-model="item.description"
        :class="['form-control', isInvalid('description') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('description', $event.target.value)">
      <div v-if="isInvalid('description')" class="invalid-feedback">{{ violations.description }}</div>
    </div>

    <div class="form-group">
      <label for="backup_status" class="form-control-label">{{$t('backup.status.name')}}</label>

      <v-select
              id="backup_status"
              v-model="item.status"
              :options="backupStatuses"
              :class="['form-control-select2', isInvalid('status') ? 'is-invalid' : '']"
              label="name"
      ></v-select>

      <div v-if="isInvalid('status')" class="invalid-feedback">{{ violations.status }}</div>
    </div>

    <div class="form-group">
      <label for="backup_assignee" class="form-control-label">{{$t('backup.assignee.name')}}</label>

      <v-select
              id="backup_assignee"
              v-model="item.assignee"
              :options="users"
              :class="['form-control-select2', isInvalid('assignee') ? 'is-invalid' : '']"
              label="name"
      ></v-select>

      <div v-if="isInvalid('assignee')" class="invalid-feedback">{{ violations.assignee }}</div>
    </div>

    <div class="form-group" :class="[isInvalid('deadline') ? 'has-error' : '']">
      <label for="backup_deadline" class="form-control-label">{{$t('backup.deadline')}}</label>

      <datepicker
          id="backup_deadline"
          v-model="item.deadline"
          name="deadline"
          monday-first
      ></datepicker>

      <div v-if="isInvalid('deadline')" class="invalid-feedback">{{ violations.deadline }}</div>
    </div>

    <div class="form-group">
      <label for="backup_project" class="form-control-label">{{$t('backup.project.name')}}</label>

      <v-select
              id="backup_project"
              v-model="item.project"
              :options="projects"
              :class="['form-control-select2', isInvalid('project') ? 'is-invalid' : '']"
              label="name"
              @search="loadProjects"
      ></v-select>

      <div v-if="isInvalid('project')" class="invalid-feedback">{{ violations.project }}</div>
    </div>

    <item-edit-actions :item="item" :entity="'Backup'" :path="'backup'"></item-edit-actions>
  </form>
</template>

<script>
import ItemEditActions from '../layout/ItemEditActions'
import { mapActions, mapGetters } from 'vuex'
import Datepicker from 'vuejs-datepicker';
import lodash from 'lodash'

export default {
  components: { ItemEditActions, Datepicker },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  created () {
    this.getBackupStatuses()
    this.getUsers()
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    },

    backupStatuses () {
      return this.$store.getters['backup_status/list/items'] || []
    },

    users () {
      return this.$store.getters['user/list/items'] || []
    },

    ...mapGetters({
      projects: 'project/list/items',
    }),
  },

  methods: {
    ...mapActions({
      getBackupStatuses: 'backup_status/list/default',
      getUsers: 'user/list/default',
      getProjects: 'project/list/default'
    }),
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    loadProjects (keyword, loading) {
      loading(true);

      this.search(loading, keyword, this);
    },

    search: _.debounce((loading, keyword, vm) => {
      vm.getProjects('/projects?name=' + keyword)
      loading(false);
    }, 350)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/backup/Form.vue